import { huggg, superhuggg, utils } from '@huggg/back-bar';
import AnalyticsService from 'services/AnalyticsService';
import { translateAPIError } from 'utilities/errorHandling';
import { UPDATE as UPDATE_HUGGG } from './huggg';

const analytics = new AnalyticsService();
const STASH = 'huggg/stash/STASH';
const STASH_SUCCESS = 'huggg/stash/STASH_SUCCESS';
const STASH_FAILURE = 'huggg/stash/STASH_FAILURE';
const RECIPIENT_NUMBER_SUBMIT = 'huggg/stash/RECIPIENT_NUMBER_SUBMIT';
const RECIPIENT_NUMBER_CHANGE = 'huggg/stash/RECIPIENT_NUMBER_CHANGE';
const RECIPIENT_EMAIL_SUBMIT = 'huggg/stash/RECIPIENT_EMAIL_SUBMIT';
const RECIPIENT_EMAIL_CHANGE = 'huggg/stash/RECIPIENT_EMAIL_CHANGE';

const defaultState = {
  stashing: false,
  stashed: false,
  isFirstStashed: false,
  view: 'input',
  error: null,
  recipientNumber: null,
  recipientEmail: null,
};

const reducer = (state = {}, { type, payload }) => {
  // doing this in the default parameters was getting a bit tricky to read!
  state = { ...defaultState, ...state };

  switch (type) {
    case STASH_SUCCESS:
      return { ...state, stashing: false, stashed: true, isFirstStashed: true };

    case RECIPIENT_NUMBER_SUBMIT:
      return { ...state, recipientNumber: payload.number, view: 'confirm' };

    case RECIPIENT_EMAIL_SUBMIT:
      return { ...state, recipientEmail: payload.email, view: 'confirm' };

    case RECIPIENT_NUMBER_CHANGE:
      return { ...state, view: 'input', error: null };

    case RECIPIENT_EMAIL_CHANGE:
      return { ...state, view: 'input', error: null };

    case STASH:
      return { ...state, stashing: true, error: null };

    case STASH_FAILURE:
      return { ...state, stashing: false, error: payload.error };

    default:
      return state;
  }
};

export default reducer;

/**
 * SIDE EFFECTS
 */
const throttled = {};
const stashThrottled = (
  action,
  resource,
  hugggId,
  { email, phoneNumber },
  method,
) => {
  const recipient = method === 'sms' ? { phoneNumber } : { email };
  const recipientValue = method === 'sms' ? phoneNumber : email;
  const key = resource + hugggId + method + recipientValue;
  throttled[key] = throttled[key]
    ? throttled[key]
    : utils.throttlePromise(() => action(hugggId, recipient, true));

  return throttled[key];
};

/**
 * Track the successful stash of a huggg or superhuggg. A bit convoluted due to
 * the nature of the way we store our data in state.
 *
 * @param {Object} huggg A regular huggg object
 * @param {Object} superhuggg A superhuggg object
 */
const trackStashSuccess = (huggg) => {
  const trackMethod = huggg.isSuperhuggg
    ? analytics.passiveCompleteSuperhugggStash
    : analytics.passiveCompleteHugggStash;

  const analyticsData = {
    hugggId: huggg.id,
    brandId: huggg.purchase.brand_id,
    brandName: huggg.purchase.brand_name,
    productId: huggg.purchase.id,
    productName: huggg.purchase.label,
  };

  trackMethod(analyticsData);
};

export const stash =
  (item, recipient, method = 'sms') =>
  (dispatch) => {
    const { isSuperhuggg } = item;
    const action = isSuperhuggg ? superhuggg.stash : huggg.stash;
    const resource = isSuperhuggg ? 'superhuggg' : 'huggg';
    dispatch({ type: STASH, payload: {} });

    const stash = stashThrottled(action, resource, item.id, recipient, method);

    return stash()
      .then((data) => {
        trackStashSuccess(item);
        const receiver = data.data;

        !item.isSuperhuggg &&
          dispatch({
            type: UPDATE_HUGGG,
            payload: {
              receiver: { id: receiver.receiver_id },
              receiver_id: receiver.receiver_id,
            },
          });

        dispatch({
          type: STASH_SUCCESS,
          payload: {},
        });
      })
      .catch((err) => {
        dispatch({
          type: STASH_FAILURE,
          payload: { error: translateAPIError(err) },
        });
      });
  };

/**
 * ACTIONS
 */
export const setRecipientNumber = (number) => (dispatch) =>
  dispatch({ type: RECIPIENT_NUMBER_SUBMIT, payload: { number } });

export const changeRecipientNumber = () => (dispatch) =>
  dispatch({ type: RECIPIENT_NUMBER_CHANGE, payload: {} });

export const setRecipientEmail = (email) => (dispatch) =>
  dispatch({ type: RECIPIENT_EMAIL_SUBMIT, payload: { email } });

export const changeRecipientEmail = () => (dispatch) =>
  dispatch({ type: RECIPIENT_EMAIL_CHANGE, payload: {} });

/**
 * SELECTORS
 */
export const isStashing = (state) => state.stash.stashing;
export const isStashed = (state) => state.stash.stashed;
export const isFirstStashed = (state) => state.stash.isFirstStashed;
export const getEmail = (state) => state.stash.recipientEmail;
export const getNumber = (state) => state.stash.recipientNumber;
export const getView = (state) => state.stash.view;
export const getError = (state) => state.stash.error;
